module.exports = __webpack_public_path__ + "static/img/logosadd.3b7ef09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logosadd.png
// module id = 570
// module chunks = 1